<template>
  <el-row>
    <el-col :span="8">aaaaa</el-col>
    <el-col :span="8">aaaaa</el-col>
    <el-col :span="8">aaaaa</el-col>
    <el-col :span="8">aaaaa</el-col>
  </el-row>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// HelloWorld.vue?10020692